export enum State {
  INIT = 'init',

  RESUME_ONBOARDING = 'resume-onboarding',
  COMPANY_INFO_RESTORED = 'company-info-restored',

  SEARCH = 'search',
  MANUAL = 'manual',
  AUTO = 'auto',
  VALIDATION = 'validation',

  COMPANY_INELIGIBLE = 'company-ineligible',

  // Service states
  SUBMISSION = 'submission',

  CONTACT_SUPPORT = 'contact-support',

  // Exit states
  DONE = 'done',
  ABORT = 'abort',
  ABORT_TO_CAPITAL_DEPOSIT = 'abort-to-capital-deposit',
}

export enum ManualState {
  INIT = 'init',

  LEGAL_FORM_QUESTION = 'legal-form-question',
  IDENTITY_INFO = 'identity-info',
  LEGAL_INFO = 'legal-info',

  DONE = 'done',
}

export enum AutoState {
  INIT = 'init',

  IS_MICRO = 'is-micro',
  IDENTITY_INFO = 'identity-info',
  LEGAL_INFO = 'legal-info',

  DONE = 'done',
}

export enum ValidationState {
  INIT = 'init',

  INFO_VERIFICATION = 'info-verification',
  EDIT_IDENTITY_INFO = 'edit-identity-info',
  EDIT_LEGAL_INFO = 'edit-legal-info',

  APE_DETAILS = 'ape-details',

  DONE = 'done',
}

export type StringifiedState =
  | Exclude<State, State.MANUAL | State.AUTO | State.VALIDATION>
  | `${State.MANUAL}.${ManualState}`
  | `${State.AUTO}.${AutoState}`
  | `${State.VALIDATION}.${ValidationState}`;
